module.exports = __webpack_public_path__ + "img/91830e08972902ccf131822ae0910afa.svg";